export interface Property {
  id: string;
  bedrooms: number;
  bathrooms: number;
  price: number;
  location: string;
  size?: string;
  description: string;
}

export interface PropertyDictionary {
  [key: string]: Property;
}

export const PROPERTIES: PropertyDictionary = {
  ABC123: {
    id: 'ABC123',
    bedrooms: 3,
    bathrooms: 2,
    price: 250000,
    location: 'Madrid',
    size: '165 metros cuadrados construidos que se quedan de 150 metros cuadrados útiles',
    // eslint-disable-next-line
    description: 'Piso moderno en zona céntrica. Está en la séptima planta por lo que es muy luminoso'
  },
  XYZ789: {
    id: 'XYZ789',
    bedrooms: 2,
    bathrooms: 1,
    price: 180000,
    location: 'Barcelona',
    size: '125 metros cuadrados',
    // eslint-disable-next-line
    description: 'Apartamento en primera línea de playa. Vistas al mar desde el salón y la habitación principal'
  },
  FRL683: {
    id: 'FRL683',
    bedrooms: 5,
    bathrooms: 5,
    price: 1300000,
    location: 'Gerona',
    size: '488 metros cuadrados',
    // eslint-disable-next-line
    description: 'Masía magníficamente restaurada, todo el exterior en piedra. Buena exposición solar todo el día y de espaldas a Tramuntana. Jardín con césped natural. Piscina impecable con gresite azul marino.'
  }
};

export interface HVARealEstateModalProps {
  show: boolean;
  title: string;
  onHide: () => void;
  agentCode: string;
  agentName: string;
  agentImage?: string;
  onError?: (error: Error) => void;
  customer?: string;
  dni?: string;
  firstMessage: string;
  prompt: string;
  voice: string;
  language: string;
}

export interface FeedbackMessage {
  id: string;
  timestamp: Date;
  type: 'nif' | 'property' | 'transfer' | 'close';
  message: string;
  details?: string;
  success?: boolean;
}
